export const toggleSavedSearchNotifications = ({ savedSearches, savedSearchId }) => {
	return savedSearches.map((searchFilter) => ({
		...searchFilter,
		notifications_enabled:
			searchFilter.id === savedSearchId
				? !searchFilter.notifications_enabled
				: searchFilter.notifications_enabled,
	}));
};
